export const statusLabel = {
  new: 'New',
  processing: 'Processing',
  entered: 'Entered',
  awaiting_law_firm_info: 'Awaiting Law Firm Info',
  vetted: 'Vetted',
  closed_not_sent: 'Closed - Not Sent',
  supervisor_review: 'Supervisor Review',
  needs_further_review: 'Needs Further Review',
  provider_outreach: 'Provider Outreach',
};
